export default "__VITE_ASSET__15e005b0__"